import styled from 'styled-components';
import theme from 'components/theme';
import { mediaDesktop } from 'breakpoints';
import Typography from 'components/Typography';
import Button from '../Button';

export const FlatPackContainer = styled.div`
  background: inherit;
  display: grid;
  align-items: start;
  justify-items: start;
  grid-template-columns: 131px 1fr;
  grid-column-gap: 24px;

  & > * {
    line-height: 1;
  }

  ${mediaDesktop} {
    grid-template-columns: 219px 1fr;
    grid-column-gap: 50px;
  }
`;

interface PackContainerProps {
  isWithBackground?: boolean;
  singlePack?: boolean;
}

export const PackContainer = styled.div<PackContainerProps>`
  background: inherit;
  display: grid;
  min-height: 240px;
  min-width: min(360px, calc(100vw - 38px));
  place-items: start;
  grid-template-columns: max(57%, 164px);
  grid-template-rows: max-content max-content;
  row-gap: 12px;
  column-gap: ${({ isWithBackground }) => (isWithBackground ? '6px' : '20px')};

  & > * {
    line-height: 1;
  }

  ${mediaDesktop} {
    min-width: auto;
    padding: 10px;
    grid-template-columns: ${({ singlePack }) => (singlePack ? '250px' : '226px')};
    grid-template-rows: ${({ singlePack }) => (
    singlePack
      ? '100px minmax(162px,max-content) min-content' : '340px minmax(162px, max-content) min-content')};  }
`;

export const PackImageWrapper = styled.div<{ singlePack?: boolean }>`
  grid-column: 1 / 2;
  grid-row: 1 / -1;
  max-width: 212px;

  ${mediaDesktop} {
    max-width: unset;
   ${({ singlePack }) => (singlePack ? 'width: 250px' : false)};
  }
`;

export const PackDescription = styled.div<{ isExpected?: boolean, singlePack?: boolean }>`
  grid-column: 2 / 3;
  align-self: ${({ singlePack }) => (singlePack ? 'center' : 'end')};
  grid-row: ${({ singlePack }) => (singlePack ? '1 / 3' : '1 / 2')};
  display: grid;
  grid-gap: 10px;

  & ${Button} {
    width: 105.05px;
    margin-left: 0;
  }

  ${mediaDesktop} {
    grid-gap: 14px;
    grid-column: ${({ singlePack }) => (singlePack ? '2 / 3' : '1 / 2')};
    align-self: ${({ singlePack }) => (singlePack ? 'center' : 'start')};
    grid-row: ${({ singlePack }) => (singlePack ? '1 / 4' : '2 / 3')};
    padding: ${({ singlePack }) => (singlePack ? '0' : '35px 0 0')};
    margin-left: ${({ isExpected }) => (isExpected ? '0' : '26px')};
    width: auto;

    & ${Button} {
      width: 85%;
      margin-top: 20px;
    }
  }
`;

export const FlatPackDescription = styled.div<{ $alignTop?: boolean }>`
  align-self: center;
  grid-row: 1 / ${({ $alignTop }) => ($alignTop ? 2 : 4)};
  grid-column: 2 / 3;
  display: grid;
  grid-gap: 12px;

  ${mediaDesktop} {
    grid-gap: 17px;
    align-self: ${({ $alignTop }) => ($alignTop ? 'start' : 'center')};
  }
`;

export const FlatPackSeparator = styled.hr`
  grid-row: 2 / 3;
  width: 100%;
  align-self: center;
  border: 0;
  border-top: 1px solid #333;
  margin: 20px 0;
`;

export const MinterRoyalty = styled(Typography)`
  color: ${theme.colors.lightGreen};
  font-size: 13px;
  line-height: 1.5;
  grid-row: 3 / 4;
  align-self: start;
  max-width: 180px;

  ${mediaDesktop} {
    font-size: 16px;
    align-self: end;
  }
`;

export const PackTitle = styled(Typography)`
   ${mediaDesktop} {
    font-size: 24px;
  }
`;

export const FlatPackTitle = styled(Typography)`
  letter-spacing: 1.7px;
  font-size: 16px;

  ${mediaDesktop} {
    font-size: 24px;
    letter-spacing: 2px;
  }
`;

export const FlatPackPrice = styled(Typography)`
  letter-spacing: 0.8px;

  ${mediaDesktop} {
    letter-spacing: 2px;
  }
`;

export const PackPrice = styled(Typography)`
  letter-spacing: 0.8px;

  ${mediaDesktop} {
    letter-spacing: 1px;
    margin-top: 4px;
    font-size: 24px;
  }
`;
